import request from "@/service";

/**
 * 直播管理列表
 * @param {*} data 
 * @returns 
 */
export function liveRoomPage(data) {
  return request({
    url: "/resource/liveRoom/page",
    method: "post",
    data,
  });
}
/**
 * 直播详情
 * @param {*} uuid 
 * @returns 
 */
export function liveRoomInfo(uuid) {
  return request({
    url:  `/resource/liveRoom/info/${uuid}`,
    method: "get",
  });
}
/**
 * 新增/编辑直播
 * @param {*} data 
 * @returns 
 */
export function saveLiveRoom(data, isEdit = false) {
  if (isEdit) {
    return request({
      url:  '/resource/liveRoom/update',
      method: "post",
      data,
    });
  } else {
    return request({
      url:  `/resource/liveRoom/save`,
      method: "post",
      data,
    });
  }
}

/**
 * 删除直播
 * @param {*} data 
 * @returns 
 */
export function deleteLiveRoom(data) {
  return request({
    url:  '/resource/liveRoom/delete',
    method: "post",
    data,
  });
}

/**
 * 直播间上下线
 * @param {*} data 
 * @returns 
 */
export function updateLiveRoomStatus(data) {
  return request({
    url:  '/resource/liveRoom/online',
    method: "post",
    data,
  });
}

// 下拉选项直播间分页列表-clc
export function getLiveRoomSelectPage(params) {
  return request({
    url: `/resource/liveRoom/selectPage`,
    method: "get",
    params
  });
}

// 拉选项预约课程分页列表-clc
export function getCourseTicketSelectPage(params) {
  return request({
    url: `/resource/courseTicket/selectPage`,
    method: "get",
    params
  });
}

// 新增弹窗
export function savePopupInfo(data) {
  return request({
    url:  '/resource/popupInfo/save',
    method: "post",
    data,
  });
}

// 修改弹窗
export function updatePopupInfo(data) {
  return request({
    url:  '/resource/popupInfo/update',
    method: "post",
    data,
  });
}

// 获取直播弹窗详情
export function getPopupInfo(id) {
  return request({
    url: `/resource/popupInfo/info/${id}`,
    method: "get"
  });
}
// 预约课程分页列表-clc
export function courseTicketPage(params) {
  return request({
    url: `/resource/courseTicket/page`,
    method: "get",
    params
  });
}

// 库存详情接口-clc
export function getTicketCount(params) {
  return request({
    url: `/resource/courseTicket/getCount`,
    method: "get",
    params
  });
}

// 预约详情接口-clc
export function getTicketInfo(params) {
  return request({
    url: `/resource/courseTicket/ticket/info`,
    method: "get",
    params
  });
}

// 预约新增接口-clc
export function addCourseTicket(data) {
  return request({
    url:  '/resource/courseTicket/ticket/add',
    method: "post",
    data,
  });
}

// 预约新增接口-clc
export function updateCourseTicket(data) {
  return request({
    url:  '/resource/courseTicket/ticket/update',
    method: "post",
    data,
  });
}

// 下拉选项限制预约课程分页列表-clc
export function selectPageLimit(params) {
  return request({
    url: `/resource/courseTicket/selectPageLimit`,
    method: "get",
    params
  });
}
/**
 * 删除课程预约
 * @param {*} data 
 * @returns 
 */
export function deleteCourseTicket(data) {
  return request({
    url:  '/resource/courseTicket/delete',
    method: "post",
    data,
  });
}
/**
 * 课程预约-上下线
 * @param {*} data 
 * @returns 
 */
export function onlineCourseTicket(data) {
  return request({
    url:  '/resource/courseTicket/online',
    method: "post",
    data,
  });
}
/**
* 课程预约-库存调整接口
* @param {*} data 
* @returns 
*/
export function setTicketCount(data) {
 return request({
   url:  '/resource/courseTicket/setCount',
   method: "post",
   data,
 });
}
// 学分修复
export function liveRepairCredit(uuid) {
  return request({
    url: `/resource/liveRoomUser/repair/${uuid}`,
    method: "get",
  });
}


export function getLiveDataPage(data) {
 return request({
   url:  '/resource/liveRoom/branchPage',
   method: "post",
   data,
 });
}

export function getLiveDataInfoPage(data) {
 return request({
   url:  '/resource/liveRoom/branchDetailPage',
   method: "post",
   data,
 });
}

export function exportLiveDataInfo(data) {
  return request({
    url: `/resource/liveRoom/exportBranchDetail`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}













